import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"
let url = "";
export default class extends Controller {
    static targets = ['form'];
    submitForm(event){
        Rails.fire(this.element, 'submit');
        window.location = event.currentTarget.getAttribute('url');
    }
}